/**
 * Utilidades para generar mensajes de contacto con fundadores de Plick
 */

import { Commerce } from '@interfaces/general';
import { generateWhatsAppLink } from './whatsappCore';

const FOUNDER_PHONE_NUMBER = '12018291495'; // +1 (201) 829-1495 - USA

export interface FounderMessageData {
  commerce: Commerce;
  message: string;
}

export function generateFounderMessage(data: FounderMessageData): string {
  const { commerce, message } = data;

  // Formato estructurado para facilitar parseo y vinculación
  return `Hola, soy ${commerce.nombre_contacto} del comercio ${commerce.nombre}.

*Mensaje:*
${message}

*Datos de contacto:*
Teléfono: ${commerce.telefono || 'No registrado'}
${commerce.correo_contacto ? `Correo: ${commerce.correo_contacto}` : ''}`.trim();
}

export function generateFounderWhatsAppLink(data: FounderMessageData): string {
  const message = generateFounderMessage(data);
  return generateWhatsAppLink(FOUNDER_PHONE_NUMBER, message);
}
